import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

function Hero() {
  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: { value: "#f5f5f5" } },
          particles: {
            number: { value: 50 },
            size: { value: 3 },
            move: { enable: true, speed: 1 },
            links: { enable: true, color: "#000" },
          },
        }}
        style={{
          position: 'absolute',
          zIndex: 0,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', pt: 20 }}>
        <Typography variant="h3" gutterBottom>
          Empower Your Business with Wondersoft
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Smart digital solutions tailored for modern businesses
        </Typography>
        <Button variant="contained" size="large" color="primary" href="#contact">
          Contact Us
        </Button>
      </Box>
    </Box>
  );
}

export default Hero;
